<ion-grid class="tip-grid">
    <ion-row *ngIf="donationProgram.roundUp">
        <ion-col>
            <ion-button class="selection-option non-tip"
                        [color]="this.selectedDonation === 'ROUND_UP' ? 'primary' : 'tertiary'"
                        (click)="changedSelected('ROUND_UP')">
                <div class="option-container">
                    <span>Round Up: {{ roundDonation | currency }}</span>
                </div>
            </ion-button>
        </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
        <ion-col *ngFor="let preset of presets" [sizeXs]="xsCol" [sizeMd]="medCol">
            <ion-button class="selection-option"
                        [color]="this.selectedDonation === preset ? 'primary' : 'tertiary'"
                        (click)="changedSelected(preset)">
                <div class="option-container">
                    <span>{{ preset | currency }}</span>
                </div>
            </ion-button>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col size-xs="6">
            <ion-button class="selection-option non-tip"
                        [color]="this.selectedDonation === 'CUSTOM' ? 'primary' : 'tertiary'"
                        (click)="clickCustom()">
                <div class="option-container">
                    <span>Custom</span>
                </div>
            </ion-button>
        </ion-col>
        <ion-col size-xs="6">
            <ion-button class="selection-option non-tip"
                        [color]="this.selectedDonation === 0 || this.selectedDonation === 'NO_DONATION' ? 'primary' : 'tertiary'"
                        (click)="changedSelected('NO_DONATION')">
                <div class="option-container">
                    <span>No Thank You</span>
                </div>
            </ion-button>
        </ion-col>
    </ion-row>
</ion-grid>
